import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartScanTunnelSessionMutationVariables = Types.Exact<{
  scanTunnelId: Types.Scalars['ID'];
  sessionId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type StartScanTunnelSessionMutation = { __typename?: 'Mutation', startScanTunnelSession: { __typename?: 'ScanTunnelSession', id: string, scan_tunnel_id: string, active_until?: string | null, is_active: boolean } };


export const StartScanTunnelSessionDocument = gql`
    mutation StartScanTunnelSession($scanTunnelId: ID!, $sessionId: String) {
  startScanTunnelSession(scan_tunnel_id: $scanTunnelId, session_id: $sessionId) {
    id
    scan_tunnel_id
    active_until
    is_active
  }
}
    `;
export type StartScanTunnelSessionMutationFn = Apollo.MutationFunction<StartScanTunnelSessionMutation, StartScanTunnelSessionMutationVariables>;

/**
 * __useStartScanTunnelSessionMutation__
 *
 * To run a mutation, you first call `useStartScanTunnelSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartScanTunnelSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startScanTunnelSessionMutation, { data, loading, error }] = useStartScanTunnelSessionMutation({
 *   variables: {
 *      scanTunnelId: // value for 'scanTunnelId'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useStartScanTunnelSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartScanTunnelSessionMutation, StartScanTunnelSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartScanTunnelSessionMutation, StartScanTunnelSessionMutationVariables>(StartScanTunnelSessionDocument, options);
      }
export type StartScanTunnelSessionMutationHookResult = ReturnType<typeof useStartScanTunnelSessionMutation>;
export type StartScanTunnelSessionMutationResult = Apollo.MutationResult<StartScanTunnelSessionMutation>;
export type StartScanTunnelSessionMutationOptions = Apollo.BaseMutationOptions<StartScanTunnelSessionMutation, StartScanTunnelSessionMutationVariables>;